if (!customElements.get("redirection-popup")) {
  customElements.define(
    "redirection-popup",
    class RedirectionPopup extends HTMLElement {
      constructor() {
        super();
        this.cookieName = "localePopup";
        this.isCookieSet = false;

        this.storeUrl = this.dataset.requestOrigin;
        this.usStoreUrl = this.dataset.usUrl;
        this.ukStoreUrl = this.dataset.ukUrl;

        this.currStoreUrl = window.shopUrl;
        this.currStoreCountry = window.Shopify.country;

        this.redirectButton = this.querySelector("#locale-redirect-to");
        this.stayButton = this.querySelector("#locale-stay");
        this.closeButton = this.querySelector(".redirection-popup-close");
        this.countryName = this.querySelector(".user-country-name");
        this.targetCountryNameCTA = this.querySelector(".user-cta-target-region");
        this.currentCountryNameCTA = this.querySelector(".user-current-region");

        this.userLocale = "";
        this.userlocaleData = {};
        this.redirectList = [];

        this.redirectList = [
          { user_country_name: "United Kingdom", user_country_code: "GB", redirectURL: this.ukStoreUrl },
          { user_country_name: "United States", user_country_code: "US", redirectURL: this.usStoreUrl },
          { user_country_name: "Australia", user_country_code: "AU", redirectURL: this.ukStoreUrl },
          { user_country_name: "Albania", user_country_code: "AL", redirectURL: this.ukStoreUrl },
          { user_country_name: "Algeria", user_country_code: "DZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Andorra", user_country_code: "AD", redirectURL: this.ukStoreUrl },
          { user_country_name: "Angola", user_country_code: "AO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Anguilla", user_country_code: "AI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Antigua & Barbuda", user_country_code: "AG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Argentina", user_country_code: "AR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Armenia", user_country_code: "AM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Aruba", user_country_code: "AW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Austria", user_country_code: "AT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Azerbaijan", user_country_code: "AZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Bahamas", user_country_code: "BS", redirectURL: this.ukStoreUrl },
          { user_country_name: "Bahrain", user_country_code: "BH", redirectURL: this.ukStoreUrl },
          { user_country_name: "Bangladesh", user_country_code: "BD", redirectURL: this.ukStoreUrl },
          { user_country_name: "Barbados", user_country_code: "BB", redirectURL: this.ukStoreUrl },
          { user_country_name: "Belgium", user_country_code: "BE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Belize", user_country_code: "BZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Benin", user_country_code: "BJ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Bermuda", user_country_code: "BM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Bhutan", user_country_code: "BT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Bolivia", user_country_code: "BO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Bosnia & Herzegovina", user_country_code: "BA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Botswana", user_country_code: "BW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Brazil", user_country_code: "BR", redirectURL: this.ukStoreUrl },
          { user_country_name: "British Virgin Islands", user_country_code: "VG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Brunei", user_country_code: "BN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Bulgaria", user_country_code: "BG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Burkina Faso", user_country_code: "BF", redirectURL: this.ukStoreUrl },
          { user_country_name: "Burundi", user_country_code: "BI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Cambodia", user_country_code: "KH", redirectURL: this.ukStoreUrl },
          { user_country_name: "Cameroon", user_country_code: "CM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Canada", user_country_code: "CA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Cape Verde", user_country_code: "CV", redirectURL: this.ukStoreUrl },
          { user_country_name: "Cayman Islands", user_country_code: "KY", redirectURL: this.ukStoreUrl },
          { user_country_name: "Chad", user_country_code: "TD", redirectURL: this.ukStoreUrl },
          { user_country_name: "Chile", user_country_code: "CL", redirectURL: this.ukStoreUrl },
          { user_country_name: "Colombia", user_country_code: "CO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Comoros", user_country_code: "KM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Congo - Brazzaville", user_country_code: "CG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Cook Islands", user_country_code: "CK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Costa Rica", user_country_code: "CR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Côte d’Ivoire", user_country_code: "CI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Croatia", user_country_code: "HR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Curaçao", user_country_code: "CW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Cyprus", user_country_code: "CY", redirectURL: this.ukStoreUrl },
          { user_country_name: "Czechia", user_country_code: "CZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Denmark", user_country_code: "DK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Djibouti", user_country_code: "DJ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Dominica", user_country_code: "DM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Dominican Republic", user_country_code: "DO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Ecuador", user_country_code: "EC", redirectURL: this.ukStoreUrl },
          { user_country_name: "Egypt", user_country_code: "EG", redirectURL: this.ukStoreUrl },
          { user_country_name: "El Salvador", user_country_code: "SV", redirectURL: this.ukStoreUrl },
          { user_country_name: "Equatorial Guinea", user_country_code: "GQ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Equatorial Guinea", user_country_code: "GQ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Eritrea", user_country_code: "ER", redirectURL: this.ukStoreUrl },
          { user_country_name: "Estonia", user_country_code: "EE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Eswatini", user_country_code: "SZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Ethiopia", user_country_code: "ET", redirectURL: this.ukStoreUrl },
          { user_country_name: "Falkland Islands", user_country_code: "FK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Faroe Islands", user_country_code: "FO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Fiji", user_country_code: "FJ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Finland", user_country_code: "FI", redirectURL: this.ukStoreUrl },
          { user_country_name: "France", user_country_code: "FR", redirectURL: this.ukStoreUrl },
          { user_country_name: "French Guiana", user_country_code: "GF", redirectURL: this.ukStoreUrl },
          { user_country_name: "French Polynesia", user_country_code: "PF", redirectURL: this.ukStoreUrl },
          { user_country_name: "Gabon", user_country_code: "GA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Gambia", user_country_code: "GM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Georgia", user_country_code: "GE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Germany", user_country_code: "DE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Ghana", user_country_code: "GH", redirectURL: this.ukStoreUrl },
          { user_country_name: "Gibraltar", user_country_code: "GI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Greece", user_country_code: "GR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Greenland", user_country_code: "GL", redirectURL: this.ukStoreUrl },
          { user_country_name: "Grenada", user_country_code: "GD", redirectURL: this.ukStoreUrl },
          { user_country_name: "Guadeloupe", user_country_code: "GP", redirectURL: this.ukStoreUrl },
          { user_country_name: "Guatemala", user_country_code: "GT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Guinea", user_country_code: "GN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Guinea-Bissau", user_country_code: "GW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Guyana", user_country_code: "GY", redirectURL: this.ukStoreUrl },
          { user_country_name: "Haiti", user_country_code: "HT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Honduras", user_country_code: "HN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Hong Kong SAR China", user_country_code: "HK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Hungary", user_country_code: "HU", redirectURL: this.ukStoreUrl },
          { user_country_name: "Iceland", user_country_code: "IS", redirectURL: this.ukStoreUrl },
          { user_country_name: "India", user_country_code: "IN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Indonesia", user_country_code: "ID", redirectURL: this.ukStoreUrl },
          { user_country_name: "Iraq", user_country_code: "IQ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Ireland", user_country_code: "IE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Israel", user_country_code: "IL", redirectURL: this.ukStoreUrl },
          { user_country_name: "Italy", user_country_code: "IT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Jamaica", user_country_code: "JM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Japan", user_country_code: "JP", redirectURL: this.ukStoreUrl },
          { user_country_name: "Jordan", user_country_code: "JO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Kazakhstan", user_country_code: "KZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Kenya", user_country_code: "KE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Kiribati", user_country_code: "KI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Kosovo", user_country_code: "XK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Kuwait", user_country_code: "KW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Kyrgyzstan", user_country_code: "KG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Laos", user_country_code: "LA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Latvia", user_country_code: "LV", redirectURL: this.ukStoreUrl },
          { user_country_name: "Lebanon", user_country_code: "LB", redirectURL: this.ukStoreUrl },
          { user_country_name: "Lesotho", user_country_code: "LS", redirectURL: this.ukStoreUrl },
          { user_country_name: "Liberia", user_country_code: "LR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Libya", user_country_code: "LY", redirectURL: this.ukStoreUrl },
          { user_country_name: "Liechtenstein", user_country_code: "LI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Lithuania", user_country_code: "LT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Luxembourg", user_country_code: "LU", redirectURL: this.ukStoreUrl },
          { user_country_name: "Macau SAR China", user_country_code: "MO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Madagascar", user_country_code: "MG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Malawi", user_country_code: "MW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Malaysia", user_country_code: "MY", redirectURL: this.ukStoreUrl },
          { user_country_name: "Maldives", user_country_code: "MV", redirectURL: this.ukStoreUrl },
          { user_country_name: "Mali", user_country_code: "ML", redirectURL: this.ukStoreUrl },
          { user_country_name: "Malta", user_country_code: "MT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Martinique", user_country_code: "MQ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Mauritania", user_country_code: "MR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Mauritius", user_country_code: "MU", redirectURL: this.ukStoreUrl },
          { user_country_name: "Mayotte", user_country_code: "YT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Mexico", user_country_code: "MX", redirectURL: this.ukStoreUrl },
          { user_country_name: "Moldova", user_country_code: "MD", redirectURL: this.ukStoreUrl },
          { user_country_name: "Monaco", user_country_code: "MC", redirectURL: this.ukStoreUrl },
          { user_country_name: "Mongolia", user_country_code: "MN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Montenegro", user_country_code: "ME", redirectURL: this.ukStoreUrl },
          { user_country_name: "Montserrat", user_country_code: "MS", redirectURL: this.ukStoreUrl },
          { user_country_name: "Morocco", user_country_code: "MA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Mozambique", user_country_code: "MZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Namibia", user_country_code: "NA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Nauru", user_country_code: "NR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Nepal", user_country_code: "NP", redirectURL: this.ukStoreUrl },
          { user_country_name: "Netherlands", user_country_code: "NL", redirectURL: this.ukStoreUrl },
          { user_country_name: "New Caledonia", user_country_code: "NC", redirectURL: this.ukStoreUrl },
          { user_country_name: "New Zealand", user_country_code: "NZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Nicaragua", user_country_code: "NI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Niger", user_country_code: "NE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Nigeria", user_country_code: "NG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Niue", user_country_code: "NU", redirectURL: this.ukStoreUrl },
          { user_country_name: "Norfolk Island", user_country_code: "NF", redirectURL: this.ukStoreUrl },
          { user_country_name: "North Macedonia", user_country_code: "MK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Norway", user_country_code: "NO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Oman", user_country_code: "OM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Pakistan", user_country_code: "PK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Palau", user_country_code: "PW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Palestinian Territories", user_country_code: "PS", redirectURL: this.ukStoreUrl },
          { user_country_name: "Panama", user_country_code: "PA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Papua New Guinea", user_country_code: "PG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Paraguay", user_country_code: "PY", redirectURL: this.ukStoreUrl },
          { user_country_name: "Peru", user_country_code: "PE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Philippines", user_country_code: "PH", redirectURL: this.ukStoreUrl },
          { user_country_name: "Pitcairn Islands", user_country_code: "PN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Poland", user_country_code: "PL", redirectURL: this.ukStoreUrl },
          { user_country_name: "Portugal", user_country_code: "PT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Qatar", user_country_code: "QA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Réunion", user_country_code: "RE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Romania", user_country_code: "RO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Russia", user_country_code: "RU", redirectURL: this.ukStoreUrl },
          { user_country_name: "Rwanda", user_country_code: "RW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Samoa", user_country_code: "WS", redirectURL: this.ukStoreUrl },
          { user_country_name: "San Marino", user_country_code: "SM", redirectURL: this.ukStoreUrl },
          { user_country_name: "São Tomé & Príncipe", user_country_code: "ST", redirectURL: this.ukStoreUrl },
          { user_country_name: "Saudi Arabia", user_country_code: "SA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Senegal", user_country_code: "SN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Serbia", user_country_code: "RS", redirectURL: this.ukStoreUrl },
          { user_country_name: "Seychelles", user_country_code: "SC", redirectURL: this.ukStoreUrl },
          { user_country_name: "Sierra Leone", user_country_code: "SL", redirectURL: this.ukStoreUrl },
          { user_country_name: "Singapore", user_country_code: "SG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Sint Maarten", user_country_code: "SX", redirectURL: this.ukStoreUrl },
          { user_country_name: "Slovakia", user_country_code: "SK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Slovenia", user_country_code: "SI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Solomon Islands", user_country_code: "SB", redirectURL: this.ukStoreUrl },
          { user_country_name: "Somalia", user_country_code: "SO", redirectURL: this.ukStoreUrl },
          { user_country_name: "South Africa", user_country_code: "ZA", redirectURL: this.ukStoreUrl },
          { user_country_name: "South Korea", user_country_code: "KR", redirectURL: this.ukStoreUrl },
          { user_country_name: "South Sudan", user_country_code: "SS", redirectURL: this.ukStoreUrl },
          { user_country_name: "Spain", user_country_code: "ES", redirectURL: this.ukStoreUrl },
          { user_country_name: "Sri Lanka", user_country_code: "LK", redirectURL: this.ukStoreUrl },
          { user_country_name: "St. Barthélemy", user_country_code: "BL", redirectURL: this.ukStoreUrl },
          { user_country_name: "St. Helena", user_country_code: "SH", redirectURL: this.ukStoreUrl },
          { user_country_name: "St. Kitts & Nevis", user_country_code: "KN", redirectURL: this.ukStoreUrl },
          { user_country_name: "St. Lucia", user_country_code: "LC", redirectURL: this.ukStoreUrl },
          { user_country_name: "St. Martin", user_country_code: "MF", redirectURL: this.ukStoreUrl },
          { user_country_name: "St. Pierre & Miquelon", user_country_code: "PM", redirectURL: this.ukStoreUrl },
          { user_country_name: "St. Vincent & Grenadines", user_country_code: "VC", redirectURL: this.ukStoreUrl },
          { user_country_name: "Sudan", user_country_code: "SD", redirectURL: this.ukStoreUrl },
          { user_country_name: "Suriname", user_country_code: "SR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Sweden", user_country_code: "SE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Switzerland", user_country_code: "CH", redirectURL: this.ukStoreUrl },
          { user_country_name: "Syria", user_country_code: "SY", redirectURL: this.ukStoreUrl },
          { user_country_name: "Taiwan", user_country_code: "TW", redirectURL: this.ukStoreUrl },
          { user_country_name: "Tajikistan", user_country_code: "TJ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Tanzania", user_country_code: "TZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Thailand", user_country_code: "TH", redirectURL: this.ukStoreUrl },
          { user_country_name: "Timor-Leste", user_country_code: "TL", redirectURL: this.ukStoreUrl },
          { user_country_name: "Togo", user_country_code: "TG", redirectURL: this.ukStoreUrl },
          { user_country_name: "Tokelau", user_country_code: "TK", redirectURL: this.ukStoreUrl },
          { user_country_name: "Tonga", user_country_code: "TO", redirectURL: this.ukStoreUrl },
          { user_country_name: "Trinidad & Tobago", user_country_code: "TT", redirectURL: this.ukStoreUrl },
          { user_country_name: "Tunisia", user_country_code: "TN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Turkey", user_country_code: "TR", redirectURL: this.ukStoreUrl },
          { user_country_name: "Turkmenistan", user_country_code: "TM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Turks & Caicos Islands", user_country_code: "TC", redirectURL: this.ukStoreUrl },
          { user_country_name: "Tuvalu", user_country_code: "TV", redirectURL: this.ukStoreUrl },
          { user_country_name: "U.S. Outlying Islands", user_country_code: "UM", redirectURL: this.ukStoreUrl },
          { user_country_name: "U.S. Virgin Islands", user_country_code: "VI", redirectURL: this.ukStoreUrl },
          { user_country_name: "Ukraine", user_country_code: "UA", redirectURL: this.ukStoreUrl },
          { user_country_name: "United Arab Emirates", user_country_code: "AE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Uruguay", user_country_code: "UY", redirectURL: this.ukStoreUrl },
          { user_country_name: "Uzbekistan", user_country_code: "UZ", redirectURL: this.ukStoreUrl },
          { user_country_name: "Vanuatu", user_country_code: "VU", redirectURL: this.ukStoreUrl },
          { user_country_name: "Vatican City", user_country_code: "VA", redirectURL: this.ukStoreUrl },
          { user_country_name: "Venezuela", user_country_code: "VE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Vietnam", user_country_code: "VN", redirectURL: this.ukStoreUrl },
          { user_country_name: "Wallis & Futuna", user_country_code: "WF", redirectURL: this.ukStoreUrl },
          { user_country_name: "Western Sahara", user_country_code: "EH", redirectURL: this.ukStoreUrl },
          { user_country_name: "Yemen", user_country_code: "YE", redirectURL: this.ukStoreUrl },
          { user_country_name: "Zambia", user_country_code: "ZM", redirectURL: this.ukStoreUrl },
          { user_country_name: "Zimbabwe", user_country_code: "ZW", redirectURL: this.ukStoreUrl },
        ];

        // fires init function
        this.init();
      }

      connectedCallback() {
        this.redirectButton.addEventListener("click", () => {
          this.setCookie(this.cookieName, "showed", 30);
          window.location = this.userlocaleData.redirectURL;
        });
        this.stayButton.addEventListener("click", () => {
          this.setCookie(this.cookieName, "showed", 30);
          this.close();
        });
        this.closeButton.addEventListener("click", () => {
          this.setCookie(this.cookieName, "showed", 30);
          this.close();
        });
      }

      async init() {
        // checks if the cookie was already set, which is set once users makes a decision on a popup
        if (this.getCookie(this.cookieName) == "showed") return;

        // Fetches user locale
        await this.checkRegion();
        // checks if user locale is present in redirect list array, shows only if it exists as we dont want to show it on every country
        if (!this.shouldShowPopup()) return;

        // updated popup content
        this.updatePopupContent();

        // opens a popup
        this.open();
      }

      async checkRegion() {
        await fetch(window.shopUrl + "/browsing_context_suggestions.json")
          // await fetch('/browsing_context_suggestions.json') // use for development
          .then((response) => response.json())
          .then((responseJson) => {
            this.userLocale = responseJson?.detected_values?.country?.handle;
            this.redirectList.forEach((item) => {
              if (item.user_country_code === this.userLocale) {
                this.userlocaleData = item;
              }
            });
          });
      }

      updatePopupContent() {
        // this code checks if the user is from US and updates the popup content accordingly
        if (
          this.userlocaleData.user_country_code == "US"
        ) {
          this.countryName.innerText = 'the US?';
          this.targetCountryNameCTA.innerText = this.userlocaleData.user_country_code;
        } else {
          this.countryName.innerText = 'outside the US?'
          this.targetCountryNameCTA.innerText = 'UK';
        }
      }

      shouldShowPopup() {
        // if this.userLocale is empty, it means that the user is not from the list of countries we want to redirect
        if (this.userLocale == undefined || this.userLocale == "") {
          return false;
        } else {
          // this code checks if the user locale is present in redirect list array and if the current store url is not the same as the redirect url (meaning user is already on the correct store)
          return this.redirectList.some(
            (item) => item.user_country_code === this.userLocale && this.currStoreUrl != item.redirectURL
          );
        }
      }

      open() {
        this.classList.add("show");
      }
      close() {
        this.classList.remove("show");
      }

      setCookie(cName, cValue, expDays) {
        let date = new Date();
        date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
      }

      getCookie(cookieName) {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();

          // Check if the cookie starts with the specified name
          if (cookie.startsWith(`${cookieName}=`)) {
            // Get the cookie value by extracting everything after the equals sign
            const value = cookie.substring(cookieName.length + 1);
            return decodeURIComponent(value);
          }
        }

        return false;
      }
    }
  );
}
